import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from "../../../../store/actions/main";
import {
       updateStepsPforte,
       updateModellPforte,
       updateTabIndexPforte,
       updateMustePforte
      } from '../../../../store/actions/pforten';
import TabSlider from '../../../../module/tabslider_new';
import {InputRadio} from '../../../../module/inputRadio';
import {muster_gerade, muster_geschwungen} from '../../../../../assets/images/pforten/muster';
import scrollToElement from '../../../../module/scrollToElement';


const Step_1 = (props) => {
   const pforten_modell = [muster_gerade, muster_geschwungen];
   const antTabArr = [{titel: 'Gerade'}, {titel: 'Geschwungen'}];
   const [tabIndex, selectTabIndex] = useState(0);
   const [muster, updateMuster] = useState('');

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
         const {index, form, titel, muster} = props.data.modell[0];
         const {tab_index} = props.data.tabs[0];
         let tab_wrapper_gerade = document.querySelectorAll('.tab_wrapper_gerade');
         let tab_wrapper_geschwungen = document.querySelectorAll('.tab_wrapper_geschwungen');
         let modal_box_header = document.querySelector('#modal_box_header');

          //update muster description
          updateMuster(muster);

          //update tab index
          selectTabIndex(tab_index);

          //scroll to Next Button Container
         scrollToElement();

         //update titel
         if (!muster) modal_box_header.innerHTML = 'Pforte';
         if (titel&&muster==='Sortiment')  modal_box_header.innerHTML = 'Pforte: '+titel;
         if (muster==='Eigenes Muster')  modal_box_header.innerHTML = 'Pforte: Eigenes Muster';

         //remove check of product box
         for(let i=0; i<tab_wrapper_geschwungen.length; i++) {
            tab_wrapper_geschwungen[i].classList.remove('check');
         }
         for(let i=0; i<tab_wrapper_gerade.length; i++) {
            tab_wrapper_gerade[i].classList.remove('check');
         }

         //check of product box
         if (index) {
            if (tab_wrapper_gerade[index] && form === 'Gerade') tab_wrapper_gerade[index].classList.add('check');
            if (tab_wrapper_geschwungen[index] && form === 'Geschwungen') tab_wrapper_geschwungen[index].classList.add('check');
         }

          //update steps
          props.updateSteps(0);
          if (index || muster==='Eigenes Muster') props.updateSteps(1);

          //Weiter-Button aktivieren
          if (index || muster==='Eigenes Muster' || props.data.allVisitedSteps) {
             props.setUpdateButtonActiveStepToFalse();
          } else {
             props.setUpdateButtonActiveStepToTrue();
          }

   }

   const selectForm = ev => {
      let modell_index = ev.currentTarget.getAttribute('index');
      let modell_titel = ev.currentTarget.getAttribute('titel');
      let modell_img = ev.target.currentSrc;
      let modell_form = ev.currentTarget.getAttribute('form');

      let modellObject = {
         index: modell_index,
         titel: modell_titel,
         img: modell_img,
         form: modell_form
      }

      props.updateModell(modellObject);
      updateItems();
   }

   const handleChangeTab = (event, newValue) => {
      selectTabIndex(newValue);
      props.updateTabIndex(newValue);
      updateItems();
   }

   const selectMuster = ev => {
      let muster = ev.target.value;
      updateMuster(muster);
      props.updateMuster(muster);
   }

   const arrayRadioItems = [
      {labalValue: 'Sortiment', labelTitel: 'Muster aus unserem Sortiment'},
      {labalValue: 'Eigenes Muster', labelTitel: 'Eigenes Muster hochladen'}
   ]

      return (
           <div className="step_wrapper">
             <h2 className="step_header">Wählen Sie eine Form für Ihre Pforte aus</h2>
              <div className="step_icon_wrapper">
                  <div className="inner_masseMenge_wrapper">
                     <div className="textfield-wrapper">
                        <InputRadio
                           arial_label='Muster'
                           name='Muster'
                           value={muster}
                           onChange={selectMuster}
                           arrayRadioItems={arrayRadioItems}
                        />
                     </div>
                  </div>
                  {muster === 'Sortiment'?
                     <div className="slider_wrapper">
                        <TabSlider
                              antTabArr={antTabArr}
                              tabPanelArr={pforten_modell}
                              onClick={selectForm}
                              imgClassName='slider_img'
                              tabIndex={tabIndex}
                              handleChangeTab={handleChangeTab}
                        />
                     </div>
               :''
               }
               {muster === 'Eigenes Muster'?<p>Im lezten Schritt haben Sie die Möglichkeit ein eigenes Muster hochzuladen.</p>:''}
              </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
      data: state.pfortenReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsPforte(ev)),
      updateModell: ev => dispatch(updateModellPforte(ev)),
      updateTabIndex: ev => dispatch(updateTabIndexPforte(ev)),
      updateMuster: ev => dispatch(updateMustePforte(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_1);
